import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from "../components/layout";
import SEO from "../components/seo";
import Example from "../components/example";
import { Link } from "gatsby";
import { graphql } from "gatsby";
export const query = graphql`
query {
  model: archieModel(name: {eq: "sound-system"}) {
    value
  }
  landscape: svgImage(args: {name: {eq: "sound-system"}, scope: {eq: null}}) {
    value
  }
  soundSystem: svgImage(args: {name: {eq: "sound-system"}, scope: {eq: "sound-system"}}) {
    value
  }
  amplifier: svgImage(args: {name: {eq: "sound-system"}, scope: {eq: "sound-system/amplifier"}}) {
    value
  }
}
`;
export const _frontmatter = {
  "title": "Context",
  "menuPosition": 4
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Layout mdxType="Layout">
      <SEO title="Context" mdxType="SEO" />
      <h1>{`Context diagram`}</h1>
      <h2>{`Description`}</h2>
      <p>{`The context diagram is designed to break down components only where useful. We find this useful to
get a 'top-down' functional impression of a system, with the option to generate diagrams that
successively 'open the lid' on components, whilst keeping others 'boxed up'.`}</p>
      <h2>{`Definition`}</h2>
      <p>{`A context diagram shows the context of the specified element, with respect to a particular `}<inlineCode parentName="p">{`scope`}</inlineCode>{` element.`}</p>
      <p>{`The view contains:`}</p>
      <ol>
        <li parentName="ol">{`Main elements of interest`}</li>
        <li parentName="ol">{`Relevant associated elements.`}</li>
      </ol>
      <h3>{`Main elements of interest`}</h3>
      <p>{`The main elements of interest are those that are children of the scoping element.
Or, if the scoping element has no children, the scoping element itself.`}</p>
      <h3>{`Relevant associated elements`}</h3>
      <p>{`A relevant associated element is one that is associated to one of the main elements of interest,
where either:`}</p>
      <ul>
        <li parentName="ul">{`Its immediate parent is an ancestor of the scope`}</li>
        <li parentName="ul">{`It is a root element.`}</li>
      </ul>
      <h2>{`Example: entire system`}</h2>
      <p>{`The simplest 'context' is one with the scope of the entire system.
All the 'top level' elements have been added (children of the world scope!).`}</p>
      <Example code="archie context model.yml" image={props.data.landscape.value} model={props.data.model.value} mdxType="Example" />
      <h2>{`Example: sub-item`}</h2>
      <p>{`If we change the scope to a sub-item, in this case `}<inlineCode parentName="p">{`sound-system`}</inlineCode>{`, we see that it is opened up
and it's two children, `}<inlineCode parentName="p">{`amplifier`}</inlineCode>{` and `}<inlineCode parentName="p">{`speaker`}</inlineCode>{` are revealed.`}</p>
      <p>{`The only connections that are shown are those that connect directly to these children.`}</p>
      <Example code="archie context model.yml --scope sound-system" image={props.data.soundSystem.value} model={props.data.model.value} mdxType="Example" />
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      